<template>
  <div class="teamManagement">
    <!-- 头部 -->
    <div class="head">
      <img src="../../assets/images/logo.png" alt="" class="logo" />
      <div class="line"></div>
      <el-button
        @click="$router.push('/controlPlatform')"
        slot="btn"
        class="backBtn"
      >
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-fanhui1"></use>
        </svg>
        返回
      </el-button>
    </div>
    <!-- 主体 -->
    <div class="teamContainer">
      <!-- 标题 -->
      <div class="title">团队管理</div>
      <!-- 容器 -->
      <div class="teamPeople">
        <!-- 团队列表左 -->
        <div class="teamLeft">
          <div class="legend">
            <span>团队列表</span>
            <el-tooltip
              content="创建团队"
              placement="top"
              effect="light"
              :open-delay="1000"
            >
              <svg fill="currentColor" @click="createTeam">
                <use xlink:href="#icon-plus"></use>
              </svg>
            </el-tooltip>
          </div>
          <!-- 团队列表 -->
          <div class="teamTable" id="teamTableID">
            <draggable @sort="sortChange" v-model="teamTableData" :filter="disableDragEle" preventOnFilter>
              <transition-group>
                <div
                  @click="getTeamList($event, item.id, item.defualt)"
                  v-for="(item, index) of teamTableData"
                  :key="item.id"
                  :class="['teamItem', teamId === item.id ? 'active' : '']"
                >
                  <div
                    class="tempCon"
                    :style="{
                      opacity: teamTimeState[index].state === 3 ? 0.6 : '',
                    }"
                  >
                    <!-- 团队名称 -->
                    <div
                      class="teamName"
                      :class="{hoverTeamName:roleCname!=='CREATER' || teamId!==item.id}"
                      :style="{
                        'padding-right':
                          teamTimeState[index].state === 3 ? '48px' : '',
                      }"
                    >
                      <img class="img" src="~@/assets/images/team.png" />
                      <div @click="teamNameHandler">
                        <el-tooltip
                          :disabled="tooltipDisabled && teamId === item.id"
                          :content="item.name"
                          placement="top-start"
                          effect="light"
                          :open-delay="1000"
                        >
                          <el-input
                            id="teamNameId"
                            maxlength="20"
                            show-word-limit
                            :readonly="roleCname !== 'CREATER' || !hasEdit || teamId!==item.id"
                            @focus="teamNameFocus(item.id, item.defualt)"
                            @change="teamNameChange(item.name1, item.id)"
                            @blur="blurHandler"
                            v-model.trim="item.name1"
                          ></el-input>
                        </el-tooltip>
                      </div>
                      <img
                        v-if="teamTimeState[index].state === 3"
                        class="failured"
                        src="../../assets/images/failured.png"
                      />
                    </div>
                    <!-- 团队内容 -->
                    <div class="content">
                      <div class="contentItem">
                        <div class="member">
                          <span
                            :style="{
                              background:
                                item.info.memberNum / item.config.maxMember >=
                                0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                          ></span
                          ><span>成员数量</span>
                        </div>
                        <div>
                          <span
                            :style="{
                              color:
                                item.info.memberNum / item.config.maxMember >=
                                0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                            class="memberActual"
                            >{{ item.info.memberNum }}</span
                          ><span>/{{ item.config.maxMember }}</span>
                          <el-tooltip
                            content="升级"
                            placement="top"
                            effect="light"
                            :open-delay="1000"
                          >
                            <img
                              id="upgradeId1"
                              @click="$router.push('/payManagement')"
                              :src="
                                item.info.memberNum / item.config.maxMember >=
                                0.8
                                  ? teamUpgradeOver
                                  : teamUpgrade
                              "
                            />
                          </el-tooltip>
                        </div>
                      </div>
                      <div class="contentItem">
                        <div class="member">
                          <span
                            :style="{
                              background:
                                item.info.mapNum / item.config.maxMap >= 0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                          ></span
                          ><span>地图数量</span>
                        </div>
                        <div>
                          <span
                            :style="{
                              color:
                                item.info.mapNum / item.config.maxMap >= 0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                            class="memberActual"
                            >{{ item.info.mapNum }}</span
                          ><span>/{{ item.config.maxMap }}</span>
                          <el-tooltip
                            content="升级"
                            placement="top"
                            effect="light"
                            :open-delay="1000"
                          >
                            <img
                              id="upgradeId2"
                              @click="$router.push('/payManagement')"
                              :src="
                                item.info.mapNum / item.config.maxMap >= 0.8
                                  ? teamUpgradeOver
                                  : teamUpgrade
                              "
                            />
                          </el-tooltip>
                        </div>
                      </div>
                      <div class="contentItem">
                        <div class="member">
                          <span
                            :style="{
                              background:
                                item.info.canvasNum / item.config.maxCanvas >=
                                0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                          ></span
                          ><span>画布数量</span>
                        </div>
                        <div>
                          <span
                            :style="{
                              color:
                                item.info.canvasNum / item.config.maxCanvas >=
                                0.8
                                  ? '#ffc149'
                                  : '',
                            }"
                            class="memberActual"
                            >{{ item.info.canvasNum }}</span
                          ><span>/{{ item.config.maxCanvas }}</span>
                          <el-tooltip
                            content="升级"
                            placement="top"
                            effect="light"
                            :open-delay="1000"
                          >
                            <img
                              id="upgradeId3"
                              @click="$router.push('/payManagement')"
                              :src="
                                item.info.canvasNum / item.config.maxCanvas >=
                                0.8
                                  ? teamUpgradeOver
                                  : teamUpgrade
                              "
                            />
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <!-- 到期时间 -->
                    <div class="dueTime">
                      <div class="time">
                        <div>到期时间</div>
                        <div class="date">
                          <span>{{ teamTimeState[index].expireTime }}</span>
                        </div>
                      </div>
                      <div class="progressContainer">
                        <div
                          v-if="teamTimeState[index].state === 1"
                          :style="{
                            width:
                              (1 - teamTimeState[index].percent) * 100 + '%',
                          }"
                          class="progress1"
                        ></div>
                        <div
                          v-if="teamTimeState[index].state === 2"
                          :style="{
                            width:
                              (1 - teamTimeState[index].percent) * 100 + '%',
                          }"
                          class="progress2"
                        ></div>
                        <div v-if="teamTimeState[index].state === 3"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 续费升级 -->
                  <span
                    id="renewalId"
                    :style="{
                      background:
                        teamTimeState[index].state === 1
                          ? 'rgba(255,255,255,0.1)'
                          : '',
                    }"
                    @click="
                      teamTimeState[index].state === 3
                        ? activateTeam()
                        : $router.push('/payManagement')
                    "
                    >{{
                      teamTimeState[index].state === 3 ? "激活" : "续费"
                    }}</span
                  >
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
        <!-- 成员列表右 -->
        <div class="peopleRight">
          <!-- 成员列表头 -->
          <div class="peopleHead">
            <div class="control">
              <div class="nameTitle">成员列表</div>
              <div class="handler" @click="showInviteMemberHandler">
                <svg width="24px" height="24px" fill="currentColor">
                  <use xlink:href="#icon-plus"></use></svg
                ><span>添加成员</span>
              </div>
              <div
                v-if="roleCname === 'CREATER' && !isDefault"
                class="handler"
                @click="dissolveTeam"
              >
                <svg width="14px" height="14px" fill="currentColor">
                  <use xlink:href="#icon-unlink"></use></svg
                ><span>解散团队</span>
              </div>
              <div
                v-if="roleCname != 'CREATER'"
                class="handler"
                @click="exitTeam"
              >
                <svg width="21px" height="21px" fill="currentColor">
                  <use xlink:href="#icon-sign-out"></use></svg
                ><span>退出团队</span>
              </div>
            </div>
            <el-input
              clearable
              maxlength="20"
              show-word-limit
              placeholder="搜索"
              prefix-icon="el-icon-search"
              v-model.trim="searchKey"
              @input="memberSearch"
            >
            </el-input>
          </div>
          <!-- 成员列表 -->
          <div class="memberContainer">
            <div class="memberhead">
              <div>成员</div>
              <div>电话号码</div>
              <div>角色</div>
              <div class="handler">操作</div>
            </div>
            <div v-if="memberTableData.length !== 0" class="memberTbody">
              <div
                class="memberhead memberDetails"
                v-for="item of memberTableData"
                :key="item.userId"
              >
                <div>
                  <img
                    :style="{
                      border:
                        item.roleName === '创建者' ? '2px solid #fbc35e' : '',
                    }"
                    :src="
                      item.profilePhoto
                        ? item.profilePhoto
                        : require('@/assets/images/head_fill.png')
                    "
                  />
                  <el-tooltip
                    :content="item.userName"
                    placement="top-start"
                    effect="light"
                    :open-delay="1000"
                  >
                    <span>{{ item.userName }}</span></el-tooltip
                  >
                  <img
                    v-if="item.roleName === '创建者'"
                    src="~@/assets/images/team-admin.png"
                  />
                </div>
                <div>{{ item.userPhone }}</div>
                <div>{{ item.roleName }}</div>
                <!-- 操作按钮 -->
                <div class="handler">
                  <div v-if="item.roleName === '创建者'">
                    <img
                      src="~@/assets/images/turn.png"
                      class="el-icon-user-solid"
                      :class="{ disable: roleCname !== 'CREATER' || isDefault }"
                      @click="
                        roleCname === 'CREATER'
                          ? isDefault
                            ? ''
                            : (showTurnOverTeamDialog = true)
                          : ''
                      "
                    />
                  </div>
                  <div v-else>
                    <i
                      class="el-icon-edit"
                      :class="{
                        disable:
                          roleCname === 'COMPILER' ||
                          roleCname === 'LOOKER' ||
                          roleCname === role[item.roleId - 1],
                      }"
                      @click="
                        roleCname === 'COMPILER' ||
                        roleCname === 'LOOKER' ||
                        roleCname === role[item.roleId - 1]
                          ? ''
                          : editMember(item)
                      "
                    ></i>
                    <i
                      class="el-icon-delete"
                      :class="{
                        disable:
                          roleCname === 'COMPILER' ||
                          roleCname === 'LOOKER' ||
                          roleCname === role[item.roleId - 1],
                      }"
                      @click="
                        roleCname === 'COMPILER' ||
                        roleCname === 'LOOKER' ||
                        roleCname === role[item.roleId - 1]
                          ? ''
                          : deleteMember(item.id)
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty">
              <Empty></Empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑成员弹窗 -->
    <editMember
      :show.sync="showEditMemberDialog"
      v-if="showEditMemberDialog"
      :memberDetail="memberDetail"
      @showMembers="getTeamList('', teamId, isDefault)"
    ></editMember>
    <!-- 移交团队弹窗 -->
    <turnOverTeam
      :show.sync="showTurnOverTeamDialog"
      v-if="showTurnOverTeamDialog"
      :teamId="teamId"
      @showMembers="getTeamList('', teamId, isDefault)"
    ></turnOverTeam>
    <!-- 邀请成员弹窗 -->
    <inviteMember
      :show.sync="showInviteMemberDialog"
      v-if="showInviteMemberDialog"
      :link="link"
    ></inviteMember>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import {
  teamList,
  createTeam,
  updateTeamName,
  userList,
  teamMove,
  roleByTeamId,
  dissolveTeamApi,
  exitTeamApi,
  deleteMemberApi,
  teamListSelect,
  switchTeam,
  teamShare
} from '@/api/teamManagement'

import editMember from './components/editMember.vue'
import turnOverTeam from './components/turnOverTeam.vue'
import inviteMember from './components/inviteMember.vue'

export default {
  name: 'teamManagement',
  props: {},
  components: { Draggable, editMember, turnOverTeam, inviteMember },
  data () {
    return {
      teamUpgrade: require('@/assets/images/team-upgrade.png'),
      teamUpgradeOver: require('@/assets/images/team-upgrade-over.png'),
      teamTableData: [], // 团队列表数据
      teamTimeState: [], // 团队到期时间数据
      searchKey: '',
      memberTableData: [], // 成员列表数据
      showEditMemberDialog: false,
      showTurnOverTeamDialog: false,
      showInviteMemberDialog: false,
      // 团队列表参数
      teamParams: {
        pageNum: 1,
        pageSize: 99
      },
      teamId: '',
      role: ['CREATER', 'ADMINISTRATOR', 'COMPILER', 'LOOKER'],
      memberDetail: '', // 编辑时单个成员详情
      isDefault: '',
      tooltipDisabled: false,
      link: '', // 邀请链接
      disableDragEle: '',
      hasEdit: false
    }
  },
  computed: {
    ...mapGetters(['userId', 'nickname', 'userInfomation', 'roleCname'])
  },
  mounted () {
    this.getTeamList()
  },
  methods: {
    // 获取团队列表 ----> 1:蓝色续费(>0.2)  2:橙色续费(<=0.2)  3:灰色已到期
    getTeamList (e, teamId = this.teamId, isDefault = this.isDefault) {
      if (
        e &&
        (e.target.id === 'teamNameId' ||
          e.target.id === 'upgradeId1' ||
          e.target.id === 'upgradeId2' ||
          e.target.id === 'upgradeId3' ||
          e.target.id === 'renewalId')
      ) {
        return
      }
      if (e && teamId === this.teamId) return
      const scrollTop = document.getElementById('teamTableID').scrollTop
      this.teamTableData = []
      this.teamTimeState = []
      teamList(this.teamParams).then((res) => {
        if (res.code === 200) {
          this.teamId = teamId || res.data.records[0].id
          this.isDefault =
            isDefault === '' ? res.data.records[0].defualt : isDefault
          this.showMembers(this.teamId, this.isDefault)
          const now = Date.now()
          res.data.records.forEach((val) => {
            val.name1 = val.name.slice(0, 20)
            let percent, state
            const expireTimestamp = new Date(val.config.expireTime).getTime() // 到期时间戳
            const validTimestamp = new Date(val.config.validTime).getTime() // 起始时间戳
            if (now >= expireTimestamp) {
              percent = 0
              state = 3
            }
            const temp =
              (expireTimestamp - now) / (expireTimestamp - validTimestamp)
            // console.log('temp: ', temp)
            if (now < expireTimestamp && temp > 0.2) {
              percent = temp > 1 ? 1 : temp
              state = 1
            }
            if (now < expireTimestamp && temp <= 0.2) {
              percent = temp
              state = 2
            }

            this.teamTimeState.push({
              expireTime: val.config.expireTime
                .split('T')[0]
                .replace(/-/g, '/'),
              percent,
              state
            })
          })
          this.teamTableData = res.data.records
          this.$nextTick(() => {
            document.getElementById('teamTableID').scrollTop = scrollTop
            this.disableDragEle = ''
            this.hasEdit = false
          })
        }
      })
    },

    // 创建团队
    createTeam () {
      createTeam().then((res) => {
        if (res.code === 200) {
          this.getTeamList()
          this.$Message('success', '创建成功')
        }
      })
    },

    // 获取到团队名称焦点时
    teamNameFocus (id, defaultTeam) {
      this.tooltipDisabled = true
      if (id !== this.teamId) {
        this.getTeamList('', id, defaultTeam)
      }
    },

    // 修改团队名称
    async teamNameChange (newName, teamId) {
      await updateTeamName({ id: teamId, name: newName })
      await this.getTeamList()
      this.$Message('success', '修改成功')
    },

    // 监听拖拽保存数据
    sortChange ({ newIndex }) {
      teamMove({
        currentId: this.teamTableData[newIndex].id,
        next: this.teamTableData[newIndex + 1]
          ? this.teamTableData[newIndex + 1].id
          : null,
        prev: this.teamTableData[newIndex - 1]
          ? this.teamTableData[newIndex - 1].id
          : null
      }).then((res) => {
        if (res.code === 200) {
          this.getTeamList()
        }
      })
    },

    // 点击团队列表显示团队成员 搜索团队成员
    showMembers (teamId, isDefault) {
      this.isDefault = isDefault
      this.teamId = teamId
      const params = {
        flag: true,
        teamId: teamId,
        keyword: this.searchKey
      }
      userList(params).then((res) => {
        if (res.code === 200) {
          this.memberTableData = res.data
        }
      })
      roleByTeamId({ teamId }).then((res) => {
        if (res.code === 200) {
          this.$store.commit('SET_ROLECNAME', res.data.roleCname)
        }
      })
    },

    // 激活团队
    activateTeam () {
      const _this = this
      this.$Submit({
        confirm: () => {
          _this.$router.push('/payManagement')
        },
        message: '团队已过期, 是否立即续费?'
      })
    },

    // 创建者解散团队
    dissolveTeam () {
      const _this = this
      this.$Delete({
        confirm: () => {
          dissolveTeamApi({ id: _this.teamId }).then((res) => {
            if (res.code === 200) {
              this.teamId = ''
              this.isDefault = ''
              this.getTeamList()
              _this.$Message('success', '操作成功')

              const teamId = Number(localStorage.getItem('teamId'))
              if (this.teamId === teamId) {
                teamListSelect().then((res) => {
                  if (res.code === 200) {
                    localStorage.setItem('teamId', res.data[0].id)
                    switchTeam({ teamId: res.data[0].id })
                  }
                })
              }
            }
          })
        },
        message: '解散团队将丢失所有数据，是否仍要解散团队?'
      })
    },

    // 退出团队
    exitTeam () {
      const _this = this
      this.$Delete({
        confirm: () => {
          exitTeamApi({ teamId: _this.teamId }).then((res) => {
            if (res.code === 200) {
              this.teamId = ''
              this.isDefault = ''
              this.getTeamList()
              _this.$Message('success', '操作成功')

              const teamId = Number(localStorage.getItem('teamId'))
              if (this.teamId === teamId) {
                teamListSelect().then((res) => {
                  if (res.code === 200) {
                    localStorage.setItem('teamId', res.data[0].id)
                    switchTeam({ teamId: res.data[0].id })
                  }
                })
              }
            }
          })
        },
        message: '是否确认退出当前团队?'
      })
    },

    // 添加成员
    showInviteMemberHandler () {
      teamShare({ teamId: this.teamId })
        .then((res) => {
          if (res.code === 200) {
            this.link = `${window.location.origin}/joinTeam/${res.data}`
            this.showInviteMemberDialog = true
          }
        })
        .catch((e) => {
          if (e.response && e.response.status === 4000) {
            this.$Delete({
              confirm: () => {
                this.$router.push('/payManagement')
              },
              message: '当前成员数量已满, 是否立即升级团队'
            })
          }
        })
    },

    // 成员列表模糊查询
    memberSearch () {
      this.getTeamList('', this.teamId, this.isDefault)
    },

    // 编辑成员
    editMember (item) {
      this.memberDetail = item
      this.showEditMemberDialog = true
    },

    // 删除成员
    deleteMember (id) {
      const _this = this
      this.$Delete({
        confirm: () => {
          deleteMemberApi(id).then((res) => {
            if (res.code === 200) {
              // this.showMembers('', this.teamId, this.isDefault)
              this.getTeamList()
              _this.$Message('success', '操作成功')
            }
          })
        },
        message: '是否确认删除该成员?'
      })
    },
    blurHandler () {
      this.tooltipDisabled = false
      this.disableDragEle = ''
      this.hasEdit = false
    },
    teamNameHandler () {
      if (this.roleCname === 'CREATER') {
        this.hasEdit = true
        this.disableDragEle = '#teamNameId'
      }
    }
  }
}
</script>

<style lang="scss">
.teamManagement {
  .teamLeft {
    user-select: none;
    .el-input .el-input__inner {
      background: transparent;
      padding-left: 5px;
      padding-right: 48px;
      // border: 0;
      // box-shadow: none;
      text-overflow: ellipsis;
      cursor: default;
    }
    .hoverTeamName{
      .el-input .el-input__inner {
      border-color: transparent;
      box-shadow: none;
    }
    }
  }
  .peopleRight {
    .peopleHead {
      .el-input .el-input__inner {
        border-radius: 16px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.teamManagement {
  width: 100vw;
  height: 100vh;
  min-height: 550px;
  position: relative;
  box-sizing: border-box;
  font-family: Source Han Sans SC;
  background: #18191a;
  text-align: left;
  .head {
    width: 100%;
    height: 48px;
    background-color: #272829;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .logo {
      margin-right: 20px;
    }
    .line {
      width: 1px;
      height: 30px;
      background-color: #4a4b4c;
      margin-right: 20px;
    }
  }
  .teamContainer {
    width: 1580px;
    height: calc(100% - 118px);
    margin: 30px auto;
    .title {
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 28px;
    }
    .teamPeople {
      width: 100%;
      height: calc(100% - 64px);
      display: flex;
      justify-content: space-between;
      .teamLeft {
        width: 300px;
        height: 100%;
        background: #353738;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.5);
        border-radius: 12px;
        .legend {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          margin-top: 17px;
          padding: 0 20px 14px 30px;
          font-size: 16px;
          svg {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 6px;
            cursor: pointer;
          }
        }
        .teamTable {
          height: calc(100% - 103px);
          margin-top: 16px;
          padding: 0 10px 0 16px;
          overflow: auto;
          .teamItem + .teamItem {
            margin-top: 12px;
          }
          .teamItem {
            width: 100%;
            border-radius: 6px;
            position: relative;
            .tempCon {
              width: 100%;
              padding: 15px 16px;
              background: rgba(255, 255, 255, 0.05);
              border-radius: 6px;
            }
            #renewalId {
              position: absolute;
              bottom: 48px;
              right: 33px;
              text-align: center;
              line-height: 18px;
              width: 36px;
              height: 18px;
              background: linear-gradient(0deg, #cb8e19, #eebd5d);
              border-radius: 4px;
              cursor: pointer;
            }
            .teamName {
              height: 35px;
              display: flex;
              align-items: center;
              padding-bottom: 14px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              position: relative;
              .img {
                margin-right: 5px;
              }
              .failured {
                position: absolute;
                right: 0;
                top: -13px;
              }
            }
            .content {
              font-size: 12px;
              margin: 15px 0;
              padding: 0 8px;
              .contentItem + .contentItem {
                margin-top: 7px;
              }
              .contentItem {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .member {
                  display: flex;
                  align-items: center;
                }
                .member > span:first-child {
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  margin-right: 5px;
                  background: rgba(255, 255, 255, 0.5);
                }
                .memberActual {
                  color: #fff;
                  font-size: 18px;
                }
                img {
                  margin-left: 7px;
                  cursor: pointer;
                }
              }
            }
            .dueTime {
              width: 100%;
              height: 66px;
              background: rgba(0, 0, 0, 0.1);
              border-radius: 6px;
              padding: 16px;
              font-size: 12px;
              .time {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 7px;
                .date {
                  padding-right: 44px;
                }
              }
              .progressContainer {
                width: 100%;
                height: 4px;
                background: rgba(0, 0, 0, 0.2);
                border-radius: 2px;
                > div {
                  height: 4px;
                  border-radius: 2px;
                }
                .progress1 {
                  background: linear-gradient(-90deg, #88ffec, #0893ff);
                }
                .progress2 {
                  background: linear-gradient(-90deg, #ffd67f, #f53939);
                }
              }
            }
          }
          .active {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
      .peopleRight {
        width: 1259px;
        height: 100%;
        background: rgba(48, 50, 51, 0.7);
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.5);
        border-radius: 12px;
        padding: 19px 40px;
        .peopleHead {
          display: flex;
          align-items: center;
          justify-content: space-between;
          white-space: nowrap;
          .control {
            display: flex;
            align-items: center;
            div {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            div + div {
              margin-left: 18px;
            }
            .nameTitle {
              font-size: 16px;
            }
            .handler {
              width: 114px;
              height: 32px;
              border: 1px solid rgba(255, 255, 255, 0.2);
              border-radius: 6px;
              padding: 0 15px;
              cursor: pointer;
            }
          }
          .el-input {
            width: 300px;
          }
        }
        .memberContainer {
          height: calc(100% - 52px);
          margin-top: 20px;
          .memberTbody {
            height: calc(100% - 43px);
            min-height: 140px;
            overflow: auto;
            > div:nth-child(odd) {
              background: rgba(255, 255, 255, 0.05);
            }
            & > div:hover {
              background: rgba(255, 255, 255, 0.2);
            }
          }
          .empty {
            margin-top: 10%;
          }
          .memberhead {
            height: 43px;
            display: flex;
            color: #aaaaaa;
            border-radius: 10px;
            div {
              width: calc((100% - 90px) / 3);
              height: 100%;
              line-height: 43px;
              padding-left: 40px;
            }
            .handler {
              width: 90px;
              padding: 0;
              div {
                padding: 0;
                display: flex;
                align-items: center;
                i + i {
                  margin-left: 20px;
                }
                i,
                img {
                  cursor: pointer;
                }
              }
              .disable {
                cursor: not-allowed;
                opacity: 0.5;
              }
            }
          }
          .memberDetails {
            height: 70px;
            color: #fff;
            div {
              line-height: 70px;
            }
            > div:first-child {
              font-size: 18px;
              display: flex;
              align-items: center;
              padding-left: 34px;
              > img:first-child {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 14px;
              }
              > span {
                max-width: 245px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              > img:last-child {
                width: 23px;
                margin-left: 7px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
